import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", { d: "M14.88 12.48c1.13-.87 1.87-2.22 1.87-3.75V6c0-2.62-2.13-4.75-4.75-4.75S7.25 3.38 7.25 6v2.73c0 1.53.74 2.88 1.87 3.75-3.41 1.19-5.87 4.44-5.87 8.25V22c0 .41.34.75.75.75h16c.41 0 .75-.34.75-.75v-1.27c0-3.81-2.46-7.06-5.87-8.25ZM8.75 8.73V6c0-1.79 1.46-3.25 3.25-3.25S15.25 4.21 15.25 6v2.73c0 1.79-1.46 3.25-3.25 3.25s-3.25-1.46-3.25-3.25Zm10.5 12.52H4.75v-.52c0-4 3.25-7.25 7.25-7.25s7.25 3.25 7.25 7.25v.52Z" }, null, -1), s = [
  n
];
function r(d, l) {
  return e(), c("svg", o, [...s]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
